import React, { useState, useEffect } from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Row,
    Spinner
} from 'reactstrap';


//CSS
import "../../../assets/css/loading.css";

//Service
import { getSessionCookie } from '../../../services/session';
import { showMessage } from '../../../services/message';
import { api_GET } from '../../../services/api_service';

//Relatorios disponiveis
import relatoriosList from '../seguranca/RelatoriosDisponiveis';

function Relatorios({ history }) {
    const [showLoading, setshowLoading] = useState(false);

    //State para pegar os relatórios disponíveis
    const [listRelatorios, setListRelatorios] = useState([]);

    const session = getSessionCookie();

    const loadRelatorios = () => {
        let components = []
        let path = window.location.href.includes("admin") ? "/admin" : "/concessionaria"
        components = relatoriosList.map(x => {
            x.layout = path
            return x;
        })

        if (session.perfil == "Master") {
            setListRelatorios(components)
        } else {
            setshowLoading(true)
            api_GET(`Usuario/GetPermissaoRelatorio/${session.usuarioId}`).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                    return;
                }
                else {
                    let _relatorios = [];
                    result.data.map(value => {
                        let relatorio = components.filter(x => x.permissao == value.permissao)[0];
                        _relatorios.push(relatorio);
                    });
                    setListRelatorios(_relatorios)
                }
            });
        }
    }

    useEffect(() => {
        loadRelatorios()
    }, []);

    return <>
        {showLoading &&
            <div className="carregandoCmp">
                <div className="box">
                    <label style={{ marginRight: "20px" }}>Carregando...</label>
                    <Spinner size="sm" color="info" />
                </div>
            </div>
        }
        <>
            <div className=" pb-4 pt-5 pt-md-7 no-print">
                <Container fluid>
                    <div className="header-body">
                        <Row>
                            {listRelatorios.map((value, index) => {
                                return <Col md="12" lg="4" className="mb-4" key={index}>
                                    <Card className="shadow">
                                        <CardHeader className="border-0 pb-0">
                                            <h3 >{value.name}</h3>
                                        </CardHeader>
                                        <CardBody className="py-3">
                                            <div className='w-100 d-flex align-items-center justify-content-end'>
                                                <Button color="primary" onClick={() => {
                                                    history.push(value.layout + value.path)
                                                }}>
                                                    VISUALIZAR RELATÓRIO
                                                </Button>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            }
                            )}
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    </>;
}

export default Relatorios;